export const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const phoneRegex = /^\+?\d?\s?\(?([0-9]{3})\)?[-.\s ]?([0-9]{3})[-.\s ]?([0-9]{4})$/;
export const wholeNumberRegex = /^\d+$/;
